import { useEffect } from 'react';
import isDevelopmentEnvironment from '../helpers/isDevelopmentEnvironment';

const deprecatedComponents: string[] = [];

function useDeprecatedWarning({ componentName, substitute }: { componentName: string; substitute: string }) {
  useEffect(() => {
    if (isDevelopmentEnvironment() && !deprecatedComponents.includes(componentName)) {
      console.warn(`${componentName} is deprecated. Use ${substitute}.`);
      deprecatedComponents.push(componentName);
    }
  }, [componentName, substitute]);
}

export default useDeprecatedWarning;
